import { render, staticRenderFns } from "./ChannelInfoModal.vue?vue&type=template&id=9c99663a&"
import script from "./ChannelInfoModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports